import { fireGoToNodeAction } from 'src/dispatcher';
import router from 'src/router';

/*
 * handleRouteChange() provides methods for handling route changes.
 * e.g back and forward actions.
 */

const handleRouteChange = () => {
  const uriParams = router.getPath().split('/');
  const nodeIndex = uriParams.pop();

  if (nodeIndex) fireGoToNodeAction({ nodeIndex });
};

export default () => {
  window.onpopstate = () => handleRouteChange();
};
